/**
 * This is intended only for INTLX Team
 * By design, this requires the page to have a script
 * tag of type "application/json" with the id of "js-config".
 */

import { usePageDataStore } from '@mc/globalStore';
import { getMergedReactTranslations } from './localeUtils';

let translations = {};

// Flagged functions
export async function updateTranslations(optionalTranslations = null) {
  if (optionalTranslations) {
    translations = { ...translations, ...optionalTranslations };
    return;
  }

  let configElement;
  try {
    const locale = usePageDataStore.getState().userData.locale;
    const translationData = await getMergedReactTranslations(locale);
    translations = {
      ...translations,
      ...translationData,
    };
  } catch {
    if (__DEV__ && configElement) {
      throw new Error(
        '@mc/translation-data: Expected JSON, received: ' +
          configElement.textContent,
      );
    } else if (__DEV__) {
      throw new Error('@mc/translation-data: Translations Element not found');
    }
  }
}

/**
 * Return the currently available translations for the current page,
 * If not yet available, update then return the translations object
 *
 * @returns {?Object}
 */
export async function readTranslations() {
  if (Object.keys(translations).length) {
    return translations;
  }
  await updateTranslations();
  return translations;
}

// Test helper function to reset translations state
export function resetTranslationsForTesting() {
  translations = {};
}

// Test helper function to set translations state
export function setTranslationsForTesting(newTranslations) {
  translations = newTranslations;
}
